import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './useAuth';

interface RequireAdminProps {
  children: React.ReactNode;
}

const RequireAdmin: React.FC<RequireAdminProps> = ({ children }) => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (!user?.isAdmin) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <h2>Access Denied</h2>
        <p>You must be a member of the MTC Architects group to access this page.</p>
      </div>
    );
  }

  return <>{children}</>;
};

export default RequireAdmin;
